import { Params, QueryParamsHandling } from '@angular/router';
import { ActionButtonVisibility } from '../types/action-button-visibility';
import { ActionButtonDisability } from '../types/action-button-disability';
import { ActionButtonType } from '../enums/action-button-type';
import { ActionButtonVariant } from '../enums/action-button-variant';
import { HtmlAnchorTarget, Nillable } from '@web/utils';
import { ActionButtonCommand } from '../types/action-button-command';
import { RouterLink } from '@web/common';

export class ActionButton<Key> {
  public constructor(
    private readonly data: {
      key: Key;
      label: string;
      visibility$: ActionButtonVisibility;
      disability$: ActionButtonDisability;
      type: ActionButtonType;
      variant: ActionButtonVariant;
      command: Nillable<ActionButtonCommand>;
      routerLink: Nillable<RouterLink>;
      url: Nillable<string>;
      target: Nillable<HtmlAnchorTarget>;
      queryParams: Nillable<Params>;
      queryParamsHandling: Nillable<QueryParamsHandling>;
    },
  ) {}

  public get key(): Key {
    return this.data.key;
  }

  public get label(): string {
    return this.data.label;
  }

  public get visibility$(): ActionButtonVisibility {
    return this.data.visibility$;
  }

  public get disability$(): ActionButtonDisability {
    return this.data.disability$;
  }

  public get type(): ActionButtonType {
    return this.data.type;
  }

  public get variant(): ActionButtonVariant {
    return this.data.variant;
  }

  public get command(): Nillable<ActionButtonCommand> {
    return this.data.command;
  }

  public get routerLink(): Nillable<RouterLink> {
    return this.data.routerLink;
  }

  public get url(): Nillable<string> {
    return this.data.url;
  }

  public get target(): Nillable<HtmlAnchorTarget> {
    return this.data.target;
  }

  public get queryParams(): Nillable<Params> {
    return this.data.queryParams;
  }

  public get queryParamsHandling(): Nillable<QueryParamsHandling> {
    return this.data.queryParamsHandling;
  }
}
